const Router = Mach.requireModule('Router');
const { statusBarHeight, navigationBarHeight } = Mach.env;

/**
 *
 * @param url 跳转到h5页面
 */
const toH5 = (url) => {
  Router.navigateTo(`sailorc://keeta.com/browser?inner_url=${encodeURIComponent(url)}`);
};

const toH5NoTitleBar = (url: string) => {
  if (url.indexOf('?') !== -1) {
    url = `${url}&sheight=${statusBarHeight}&nheight=${navigationBarHeight}`;
  } else {
    url = `${url}?sheight=${statusBarHeight}&nheight=${navigationBarHeight}`;
  }
  Router.navigateTo(`sailorc://keeta.com/browser?notitlebar=1&future=2&inner_url=${encodeURIComponent(url)}`);
};

export { toH5, toH5NoTitleBar };
